import {
	QueryClient, defaultShouldDehydrateQuery, isServer,
} from '@ts-rest/react-query/tanstack';

function makeQueryClient() {
	const TEN_MINUTES = 600000;

	return new QueryClient({
		defaultOptions: {
			dehydrate: {
				shouldDehydrateQuery: query =>
					defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
			},
			queries: {
				refetchOnWindowFocus: false,
				staleTime:            TEN_MINUTES,
			},
		},
	});
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
	if (isServer) {
		return makeQueryClient();
	}
	else {
		if (!browserQueryClient) browserQueryClient = makeQueryClient();

		return browserQueryClient;
	}
}
